import React from 'react';
import { useNavigate } from 'react-router-dom';
import WebDeveloperContent from '../WebDeveloperContent/WebDeveloperContent';
import styles from './GraphicDesignContact.module.css';

const GraphicDesignContact = ({ onModeChange }) => {
  const navigate = useNavigate();

  const allSkills = [
    { name: 'Download CV', icon: '📄', primary: true },
    { name: 'Get In Touch', icon: '✉️', primary: true },
    { name: 'CSS', icon: '🎨', color: 'rgba(228, 77, 38, 0.2)' },
    { name: 'Figma', icon: '🎨', color: 'rgba(162, 89, 255, 0.2)' },
    { name: 'HTML5', icon: '🌐', color: 'rgba(228, 77, 38, 0.2)' },
    { name: 'Svelte', icon: '⚡', color: 'rgba(255, 62, 0, 0.2)' },
    { name: 'Flutter', icon: '📱', color: 'rgba(2, 86, 155, 0.2)' },
    { name: 'CorelDraw', icon: '✏️', color: 'rgba(0, 169, 92, 0.2)' },
    { name: 'WordPress', icon: '📝', color: 'rgba(33, 117, 155, 0.2)' },
    { name: 'JavaScript', icon: '💻', color: 'rgba(247, 223, 30, 0.2)' },
    { name: 'Tailwind CSS', icon: '🎨', color: 'rgba(6, 182, 212, 0.2)' },
    { name: 'Adobe Animate', icon: '🎬', color: 'rgba(168, 85, 247, 0.2)' },
    { name: 'After Effects', icon: '✨', color: 'rgba(59, 130, 246, 0.2)' },
    { name: 'Procreate App', icon: '🖌️', color: 'rgba(236, 72, 153, 0.2)' },
    { name: 'Adobe Photoshop', icon: '📷', color: 'rgba(59, 130, 246, 0.2)' },
    { name: 'Adobe InDesign', icon: '📄', color: 'rgba(236, 72, 153, 0.2)' },
    { name: 'Graphic Design', icon: '🎨', color: 'rgba(255, 215, 0, 0.2)' },
    { name: 'Adobe Illustrator', icon: '🎭', color: 'rgba(139, 92, 246, 0.2)' },
    { name: 'Adobe Premier Pro', icon: '🎬', color: 'rgba(168, 85, 247, 0.2)' },
    { name: 'Vector Illustration', icon: '🖼️', color: 'rgba(139, 92, 246, 0.2)' },
    { name: 'Software Developer', icon: '💻', color: 'rgba(74, 144, 226, 0.2)' },
    { name: 'Adobe Premiere Pro', icon: '🎬', color: 'rgba(168, 85, 247, 0.2)' },
    { name: 'Web Application Design', icon: '🌐', color: 'rgba(228, 77, 38, 0.2)' },
    { name: 'Motion Graphics', icon: '👻', color: 'rgba(168, 85, 247, 0.2)' }
  ];

  return (
    <>
      <WebDeveloperContent onModeChange={onModeChange} />

      {/* Contact Section */}
      <section id="contact" className={styles.contactSection}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Let's Create Together</h2>
          <p className={styles.contactText}>Ready to bring your vision to life</p>
          
          {/* Skills Pills */}
          <div className={styles.skillsRowDark}>
            {allSkills.map((skill, index) => (
              skill.name === 'Download CV' ? (
                <a
                  key={index}
                  href={require('../../images/Pavithra Chandran.pdf')}
                  download="Pavithra Chandran.pdf"
                  className={`${styles.skillPillDark} ${styles.primaryPill}`}
                  style={{ textDecoration: 'none' }}
                >
                  <span className={styles.skillIcon}>{skill.icon}</span>
                  <span>{skill.name}</span>
                </a>
              ) : (
                <div
                  key={index}
                  className={`${styles.skillPillDark} ${skill.primary ? styles.primaryPill : ''}`}
                  style={!skill.primary ? { backgroundColor: skill.color } : {}}
                  onClick={() => skill.name === 'Get In Touch' && navigate('/contact')}
                >
                  <span className={styles.skillIcon}>{skill.icon}</span>
                  <span>{skill.name}</span>
                </div>
              )
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <div className={styles.footer}>
        <p>Crafted with creativity and passion ✨</p>
      </div>
    </>
  );
};

export default GraphicDesignContact;